import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_CHANGEMENT_RL_VALIDATION_TOKEN,
    CONTEXT_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
} from '../../../constants/apiUrls.constants';

const changementResponsableLegal = combineReducers({
    validationToken: APIReducer.bind(null, CONTEXT_CHANGEMENT_RL_VALIDATION_TOKEN),
    reinitialiserCredentials: APIReducer.bind(
        null,
        CONTEXT_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
    ),
});

export default changementResponsableLegal;
